import { ChangeDetectionStrategy, Component, OnInit, forwardRef } from '@angular/core';
import { RouterLink } from '@angular/router';
import { StickyNativeDirective } from '@df/legacy/ui/sticky/sticky-native.directive';
import { NGhostProducts } from '@df/module-ghost-products/ghost-products.namespace';
import { GhostProductsService } from '@df/module-ghost-products/ghost-products.service';
import { NgInject } from '@df/ng/ng-inject';
import { SizeClassDirective } from '@df/ui/common/size-class.directive';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsComponent, ICmsContent, NICmsContentComponent } from '@icms/core/content';
import { SwiperModule } from 'swiper/angular';
import { ProductComponent } from '../../../product/product.component';
let uid = 0;
@ICmsComponent<PageComponentAddOnsComponent>({
    id: 'add-ons',
    name: 'Add-Ons',
    tags: ['basket', 'checkout', 'carousel'],
    hidePreview: true,
    fields: []
})
@Component({
    selector: 'page-component-add-ons',
    templateUrl: 'add-ons.html',
    styleUrls: ['./add-ons.scss'],
    standalone: true,
    imports: [SizeClassDirective, SwiperModule, forwardRef(() => ProductComponent), StickyNativeDirective, RouterLink, TranslationModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PageComponentAddOnsComponent extends UiComponent implements NICmsContentComponent.IComponent, OnInit {
    @ICmsContent({
        type: 'component'
    })
    component: NICmsContentComponent.IData;
    @NgInject(GhostProductsService)
    ghostProductsService: GhostProductsService;
    data: NGhostProducts.IOfferPrepared;
    protected uid = uid++;
    override async ngOnInit() {
        super.ngOnInit();
        try {
            const result = await this.ghostProductsService.load();
            this.data = result && result[0];
        } catch (err) {
            this.data = undefined;
        }
        this.detectChanges();
    }
}
